import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const roundShimmerKeyframes = keyframes(["0%{background-position:-40px 0;}100%{background-position:40px 0;}"]);
const StyledRound = styled.div.withConfig({
  displayName: "DataPassingPanelBodyNestedSkeleton__StyledRound",
  componentId: "sc-3qjpxo-0"
})(["display:inline-block;border-radius:", ";width:20px;height:20px;background:linear-gradient( 106deg,", ",", ",", ",", " );animation:", " 15000ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.borderRadius[300], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-disabled'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], roundShimmerKeyframes);
const textShimmerKeyframes = keyframes(["0%{background-position:-300px 0;}100%{background-position:300px 0;}"]);
const StyledText = styled.div.withConfig({
  displayName: "DataPassingPanelBodyNestedSkeleton__StyledText",
  componentId: "sc-3qjpxo-1"
})(["display:inline-block;border-radius:", ";width:150px;height:20px;margin-left:", ";background:linear-gradient( 106deg,", ",", ",", ",", " );animation:", " 15000ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.borderRadius[300], ({
  theme
}) => theme.space[250], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-disabled'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], textShimmerKeyframes);
const DataPassingPanelBodyNestedSkeleton = () => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": 'data-panel-source-skeleton',
    children: [/*#__PURE__*/_jsx(StyledRound, {}), /*#__PURE__*/_jsx(StyledText, {})]
  });
};
export default DataPassingPanelBodyNestedSkeleton;